<template>
  <v-menu
    ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
  
    <!-- {{disabled}} -->
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        hint="DD/MM/YYYY format"
        persistent-hint
        prepend-icon="event"
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
        :rules="requiredTrue"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker :min="minDate" :max="maxDate" v-model="date" no-title @input="menu1 = false"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ["inputData"],
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    label: "",
    requiredTrue: [],
    fieldRules: [v => !!v || "Field is required"],
    disabled: false,
    minDate: "",
    maxDate:'',

    //date2: new Date().toISOString().substr(0, 10),
  }),

  computed: {},

  mounted: function() {},

  created() {    
   // console.log("inputData created", this.inputData);
    this.setDateFieldValue();    
  },

  watch: {

    date(val) {
      //console.log('watch ', this.date)
      this.dateFormatted = this.formatDate(this.date);
      this.inputData["value"] = this.dateFormatted;
      //console.log("val", this.dateFormatted);
      this.$emit("setValue", this.inputData);
    }
  },

  methods: {
    setRange(date) {
      //console.log('dt===', date);
      this.setDateFieldValue()

      this.disabled = true;
      if (!date) return null;

      const d = date.split("/");
      let minValue = d[2] + "-" + d[1] + "-" + d[0];
      //console.log('dt a===', a);

      this.minDate = minValue;
      this.disabled = false;
      this.date = "";
    },

    setDateFieldValue() {

    this.dateFormatted =
      typeof this.inputData !== "undefined" ? this.inputData.fieldValue : "";
    this.label =
      typeof this.inputData != "undefined" ? this.inputData.label : "";

    if (typeof this.inputData != "undefined" && this.inputData.required == 1) {
      this.requiredTrue = this.fieldRules;
    }

    if (typeof this.inputData != "undefined" && this.inputData.currentDate == 1) {
      this.maxDate = new Date().toISOString().substr(0, 10)
    }

    if (typeof this.inputData != "undefined" && this.inputData.disabled == 1) {
      this.disabled = true;
    }

    if (
      typeof this.inputData != "undefined" &&
      typeof this.inputData.minDate !== "undefined" &&
      this.inputData.minDate !== null &&
      this.inputData.minDate !== '' &&
      this.inputData.minDate != "00/00/0000"
    ) {
      //console.log('this.inputData.minDate', this.inputData.minDate);
      const dt = this.inputData.minDate;
      //console.log('dt == ', dt);
      const d = dt.split("/");
      let minValue = d[2] + "-" + d[1] + "-" + d[0];
      this.minDate = minValue;
      //this.date = minValue;
      //console.log('dt', minValue);
    }
  },

    allowedDates(val) {
      return parseInt(val.split("-")[2], 10) % 2 === 0;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
      //return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    setDateValue(data)
    {     
      this.date = data.value // auto call to watch date function
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/global/date_picker.vue